import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { uuid } from "../../helpers/common";
import { clearfileUpload, uploadPostFile } from "../../actions/user";
import { FILE_STORAGE_GOOGLE } from "../../constants";
import config from "../../constants/config";
import { getFbLoginStatus, getFbUserDetail, loginFB, logoutFB, sharePost } from "../../helpers/fb";
import { getUserAuthProviderList } from "../../actions/users";
import { toastSuccess } from "../../actions/toast";
import Modal from "./Modal";

const fbShareIcon = require('../../../assets/images/fb-share.svg');

const FbPost = ({ isLoading, chartName, title, description, getImageUrl, isShow = false }) => {

    const [isSharing, setIsSharing] = useState(false);
    const [shouldReconnect, setShouldReconnect] = useState(false);
    const { isUploading, url } = useSelector(state => state.user.fileUpload);
    const dispatch = useDispatch();

    const [modalState, setModalState] = useState({
        show: false,
        message: '',
        icon: ''
    })
    const showModal = (message) => setModalState({ ...modalState, show: true, message });
    const hideModal = () => {
        setModalState({ ...modalState, show: false, message: '' });
        setIsSharing(false);
    }

    useEffect(() => {

        const shareFbPost = async () => {
            const mediaDetailURL = encodeURI(`${config.common.APP_API_URL}/api/social/fb/post/${url}/${chartName}/${title}/${description}`);
            const postResponse = await sharePost(mediaDetailURL);
            postResponse && dispatch(toastSuccess('Post shared to facebook successfully'));
            dispatch(clearfileUpload());
            setIsSharing(false);
        }

        if (!isUploading && url) shareFbPost();
    }, [isUploading, url]);

    const uploadFile = async () => {

        const imageUrl = await getImageUrl();
        dispatch(
            uploadPostFile({
                storage: FILE_STORAGE_GOOGLE,
                file: imageUrl,
                name: `${uuid()}.png`,
            })
        );
    }

    const getFbUserData = async (type) => {
        const loginStatus = await getFbLoginStatus(); // get existing fb login status
        const userDetail = (loginStatus.status === 'connected') ? await getFbUserDetail() : null;
        const authType = (userDetail && userDetail.error) ? 'reauthenticate' : type; // reauthenticate user if user logout from the browser

        if (authType === 'reauthenticate' || !loginStatus || !(loginStatus.status === 'connected')) {
            const loginResponse = await loginFB(authType);
            if (!loginResponse) return null; // if user exit from fb login page
        }
        return await getFbUserDetail();
    }

    const isFbProvider = providers => Array.isArray(providers) && providers.filter(p => p.authentication_provider_id === 2).length > 0;

    const handleAuthProviders = async (providers, type) => {

        if (!isFbProvider(providers)) {
            showModal('Your facebook account is not configured at this moment. Please contact administrator and have it configured.');
            return;
        }

        let userDetail = await getFbUserData(type);

        if (!userDetail) {
            setIsSharing(false);
            return;
        }
        if (userDetail.error) {
            showModal(userDetail.error.message || `Something went wrong. please try again.`);
            return;
        }

        const validLogin = providers.find(p => p.authentication_provider_id === 2 && p.authentication_login === userDetail.email);

        if (!validLogin) {
            await logoutFB();
            showModal(`You have logged into facebook with the email ${userDetail.email ? `'${userDetail.email}'` : ''} which is not configured to this account. Do you want to retry with different account?`);
            setIsSharing(false);
            setShouldReconnect(true);
            return;
        }

        uploadFile();
    }

    const handleFbPost = (type) => {
        if (!window.FB) return;
        setShouldReconnect(false);
        setIsSharing(true);
        dispatch(getUserAuthProviderList((authProviders) => handleAuthProviders(authProviders, type)));
    }

    if (isShow) {
        return (
            <>
                <div
                    title="Share to Facebook"
                    onClick={() => handleFbPost()}
                    className={`facebook-share ${(isSharing || isLoading) ? 'disabled' : ''}`}>
                    <img src={fbShareIcon} className="share-icon" alt="fb-share" />

                </div>

                {modalState.show && <Modal.Confirm
                    title={{
                        className: 'd-none'
                    }}
                    confirmButton={{
                        content: 'Continue',
                        className: `${shouldReconnect ? '' : 'd-none'}`,
                    }}
                    cancelButton={{
                        content: `${shouldReconnect ? 'Cancel' : 'OK'}`
                    }}
                    show={modalState.show}
                    onConfirm={() => handleFbPost('rerequest')}
                    iconClassName="fa fa-times"
                    body={modalState.message}
                    onHide={hideModal} />
                }
            </>
        );
    } else {
        return (<></>)
    }
}

export default FbPost;
